import { getCurrentUserIdToken } from '@/services/auth'
import { errorIfInvalidResponse } from './errors'
import { composedFetch, getDrivesURL } from './helpers'
import { DriveData } from '@/store/types/drive'

async function drivePatch(uuid: string, bodyObj?: DriveData): Promise<Response> {
  return composedFetch('PATCH', getDrivesURL(uuid), await getCurrentUserIdToken(), bodyObj)
}

export const apiUpdateDrive = async (
  uuid: string,
  name: string,
  customDriveLetter: string,
): Promise<void> => {
  const setupInfoObject: DriveData = {
    name,
    custom_drive_letter: customDriveLetter,
  }
  const response = await drivePatch(uuid, setupInfoObject)
  await errorIfInvalidResponse(response)
}
